"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UnsubscribedErrorMessageComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    warningIcon: {
      marginRight: spacing(2),
      color: palette.error.dark,
      width: '24px !important',
      height: '24px !important'
    }
  };
});

var UnsubscribedErrorMessageComponent = function UnsubscribedErrorMessageComponent() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    pt: 2,
    pb: 2,
    pl: 3,
    pr: 7,
    mb: 1,
    bgcolor: "error.light",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    className: classes.warningIcon,
    icon: "exclamation-circle"
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-White-Bold"
  }, "Sorry, this person has opted-out of Alyce gifts."));
};

exports.UnsubscribedErrorMessageComponent = UnsubscribedErrorMessageComponent;

var _default = /*#__PURE__*/(0, _react.memo)(UnsubscribedErrorMessageComponent);

exports.default = _default;